import React, { useState, useEffect } from 'react';
import AdminSidebar from '../../components/AdminSidebar';
import AdminHeader from '../../components/AdminHeader';
import './OrdersManagement.css';

// Données fictives pour la démonstration
const demoOrders = [
  { 
    id: "ORD5623", 
    customer: "Jean Dupont", 
    customerPhone: "06 12 34 56 78",
    customerEmail: "jean.dupont@email.com",
    restaurant: "Le Gourmet", 
    items: [
      { name: "Filet Mignon", quantity: 1, price: 28.50 },
      { name: "Risotto aux Cèpes", quantity: 1, price: 18.90 },
      { name: "Crème Brûlée", quantity: 1, price: 8.50 }
    ],
    totalAmount: 55.90,
    status: "Livré",
    orderDate: "2025-04-14T14:32:00",
    deliveryDate: "2025-04-14T15:15:00",
    deliveryAddress: "12 Rue de la Paix, 75001 Paris",
    paymentMethod: "Carte bancaire",
    deliveryPerson: "Thomas Leroy"
  },
  { 
    id: "ORD5622", 
    customer: "Marie Leroy", 
    customerPhone: "07 23 45 67 89",
    customerEmail: "marie.leroy@email.com",
    restaurant: "Sushi Master", 
    items: [
      { name: "Sushi Mix", quantity: 1, price: 22.90 },
      { name: "Mochi Glacé", quantity: 1, price: 6.90 }
    ],
    totalAmount: 29.80,
    status: "En cours de livraison",
    orderDate: "2025-04-14T13:15:00",
    deliveryDate: null,
    deliveryAddress: "24 Avenue Victor Hugo, 75016 Paris",
    paymentMethod: "Carte bancaire",
    deliveryPerson: "Lucas Martin"
  },
  { 
    id: "ORD5621", 
    customer: "Thomas Martin", 
    customerPhone: "06 34 56 78 90",
    customerEmail: "thomas.martin@email.com",
    restaurant: "Pizza Express", 
    items: [
      { name: "Pizza Margherita", quantity: 2, price: 25.80 },
      { name: "Pizza Quattro Formaggi", quantity: 1, price: 14.90 },
      { name: "Tiramisu", quantity: 2, price: 15.00 }
    ],
    totalAmount: 55.70,
    status: "Préparation",
    orderDate: "2025-04-14T12:48:00",
    deliveryDate: null,
    deliveryAddress: "8 Rue du Faubourg Saint-Honoré, 75008 Paris",
    paymentMethod: "PayPal",
    deliveryPerson: null
  },
  { 
    id: "ORD5620", 
    customer: "Lucie Bernard", 
    customerPhone: "07 45 67 89 01",
    customerEmail: "lucie.bernard@email.com",
    restaurant: "Le Gourmet", 
    items: [
      { name: "Risotto aux Cèpes", quantity: 1, price: 18.90 }
    ],
    totalAmount: 18.90,
    status: "Livré",
    orderDate: "2025-04-14T11:30:00",
    deliveryDate: "2025-04-14T12:05:00",
    deliveryAddress: "32 Rue de Rivoli, 75004 Paris",
    paymentMethod: "Carte bancaire",
    deliveryPerson: "Sophie Dubois"
  },
  { 
    id: "ORD5619", 
    customer: "Antoine Petit", 
    customerPhone: "06 56 78 90 12",
    customerEmail: "antoine.petit@email.com",
    restaurant: "Burger House", 
    items: [
      { name: "Cheese Burger", quantity: 2, price: 25.80 },
      { name: "Frites", quantity: 2, price: 7.80 },
      { name: "Coca-Cola", quantity: 2, price: 6.00 }
    ],
    totalAmount: 39.60,
    status: "Commande reçue",
    orderDate: "2025-04-14T10:22:00",
    deliveryDate: null,
    deliveryAddress: "15 Boulevard Saint-Germain, 75005 Paris",
    paymentMethod: "Carte bancaire",
    deliveryPerson: null
  }
];

// Liste des livreurs disponibles
const deliveryPersons = [
  "Thomas Leroy",
  "Lucas Martin",
  "Sophie Dubois",
  "Julien Moreau",
  "Camille Petit"
];

const OrdersManagement = () => {
  const [orders, setOrders] = useState(demoOrders);
  const [filteredOrders, setFilteredOrders] = useState(demoOrders);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [dateFilter, setDateFilter] = useState('all');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  
  // Simuler un chargement de données depuis une API
  useEffect(() => {
    // Dans un cas réel, vous feriez un appel API ici
    // fetch('/api/admin/orders')
    //   .then(response => response.json())
    //   .then(data => {
    //     setOrders(data);
    //     setFilteredOrders(data);
    //   });
  }, []);
  
  // Filtrer les commandes selon les critères
  useEffect(() => {
    let result = orders;
    
    // Filtrage par terme de recherche
    if (searchTerm) {
      result = result.filter(order => 
        order.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.customer.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.restaurant.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    // Filtrage par statut
    if (statusFilter !== 'all') {
      result = result.filter(order => order.status === statusFilter);
    }
    
    // Filtrage par date
    if (dateFilter !== 'all') {
      const today = new Date();
      const todayStart = new Date(today.setHours(0, 0, 0, 0));
      const todayEnd = new Date(today.setHours(23, 59, 59, 999));
      
      switch (dateFilter) {
        case 'today':
          result = result.filter(order => {
            const orderDate = new Date(order.orderDate);
            return orderDate >= todayStart && orderDate <= todayEnd;
          });
          break;
        case 'week':
          const weekStart = new Date();
          weekStart.setDate(weekStart.getDate() - 7);
          result = result.filter(order => {
            const orderDate = new Date(order.orderDate);
            return orderDate >= weekStart;
          });
          break;
        case 'month':
          const monthStart = new Date();
          monthStart.setMonth(monthStart.getMonth() - 1);
          result = result.filter(order => {
            const orderDate = new Date(order.orderDate);
            return orderDate >= monthStart;
          });
          break;
        default:
          break;
      }
    }
    
    setFilteredOrders(result);
  }, [orders, searchTerm, statusFilter, dateFilter]);
  
  const handleViewOrder = (order) => {
    setSelectedOrder(order);
    setShowOrderDetails(true);
  };
  
  const handleUpdateStatus = (orderId, newStatus) => {
    const updatedOrders = orders.map(order => {
      if (order.id === orderId) {
        return { ...order, status: newStatus };
      }
      return order;
    });
    
    setOrders(updatedOrders);
    
    if (selectedOrder && selectedOrder.id === orderId) {
      setSelectedOrder({ ...selectedOrder, status: newStatus });
    }
  };
  
  const handleAssignDelivery = (orderId, deliveryPerson) => {
    const updatedOrders = orders.map(order => {
      if (order.id === orderId) {
        return {
          ...order,
          deliveryPerson,
          status: order.status === "Commande reçue" ? "Préparation" : order.status
        };
      }
      return order;
    });
    
    setOrders(updatedOrders);
    
    if (selectedOrder && selectedOrder.id === orderId) {
      setSelectedOrder({
        ...selectedOrder,
        deliveryPerson,
        status: selectedOrder.status === "Commande reçue" ? "Préparation" : selectedOrder.status
      });
    }
  };
  
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  
  const getStatusClass = (status) => {
    switch (status) {
      case "Commande reçue":
        return "status-received";
      case "Préparation":
        return "status-preparing";
      case "En cours de livraison":
        return "status-delivering";
      case "Livré":
        return "status-delivered";
      default:
        return "";
    }
  };
  
  const closeModal = () => {
    setShowOrderDetails(false);
    setSelectedOrder(null);
  };

  return (
    <div className="admin-dashboard">
      <AdminSidebar />
      <div className="dashboard-content">
        <AdminHeader title="Gestion des Commandes" />
        
        <div className="orders-container">
          <div className="filters-bar">
            <div className="search-box">
              <input 
                type="text" 
                placeholder="Rechercher par ID, client ou restaurant..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button className="search-button">Rechercher</button>
            </div>
            
            <div className="filter-options">
              <div className="filter-group">
                <label>Statut:</label>
                <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                  <option value="all">Tous les statuts</option>
                  <option value="Commande reçue">Commande reçue</option>
                  <option value="Préparation">Préparation</option>
                  <option value="En cours de livraison">En cours de livraison</option>
                  <option value="Livré">Livré</option>
                </select>
              </div>
              
              <div className="filter-group">
                <label>Date:</label>
                <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)}>
                  <option value="all">Toutes les dates</option>
                  <option value="today">Aujourd'hui</option>
                  <option value="week">Cette semaine</option>
                  <option value="month">Ce mois</option>
                </select>
              </div>
            </div>
          </div>
          
          <div className="orders-table-container">
            <table className="orders-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Date</th>
                  <th>Client</th>
                  <th>Restaurant</th>
                  <th>Montant</th>
                  <th>Statut</th>
                  <th>Livreur</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrders.map(order => (
                  <tr key={order.id}>
                    <td>{order.id}</td>
                    <td>{formatDate(order.orderDate)}</td>
                    <td>{order.customer}</td>
                    <td>{order.restaurant}</td>
                    <td>{order.totalAmount.toFixed(2)} €</td>
                    <td>
                      <span className={`status-badge ${getStatusClass(order.status)}`}>
                        {order.status}
                      </span>
                    </td>
                    <td>{order.deliveryPerson || "Non assigné"}</td>
                    <td className="actions-cell">
                      <button 
                        className="action-button view-button" 
                        onClick={() => handleViewOrder(order)}
                      >
                        Détails
                      </button>
                      <div className="dropdown">
                        <button className="action-button status-button">
                          Modifier Statut
                        </button>
                        <div className="dropdown-content">
                          <button onClick={() => handleUpdateStatus(order.id, "Commande reçue")}>Commande reçue</button>
                          <button onClick={() => handleUpdateStatus(order.id, "Préparation")}>Préparation</button>
                          <button onClick={() => handleUpdateStatus(order.id, "En cours de livraison")}>En cours de livraison</button>
                          <button onClick={() => handleUpdateStatus(order.id, "Livré")}>Livré</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {/* Modal pour les détails de commande */}
          {showOrderDetails && selectedOrder && (
            <div className="modal-backdrop">
              <div className="order-details-modal">
                <button className="close-modal" onClick={closeModal}>×</button>
                <h2>Détails de la commande {selectedOrder.id}</h2>
                
                <div className="order-info-grid">
                  <div className="order-info-section">
                    <h3>Informations Client</h3>
                    <div className="info-row">
                      <span className="info-label">Nom:</span>
                      <span className="info-value">{selectedOrder.customer}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Téléphone:</span>
                      <span className="info-value">{selectedOrder.customerPhone}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Email:</span>
                      <span className="info-value">{selectedOrder.customerEmail}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Adresse:</span>
                      <span className="info-value">{selectedOrder.deliveryAddress}</span>
                    </div>
                  </div>
                  
                  <div className="order-info-section">
                    <h3>Informations Commande</h3>
                    <div className="info-row">
                      <span className="info-label">Restaurant:</span>
                      <span className="info-value">{selectedOrder.restaurant}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Date de commande:</span>
                      <span className="info-value">{formatDate(selectedOrder.orderDate)}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Date de livraison:</span>
                      <span className="info-value">{formatDate(selectedOrder.deliveryDate)}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Moyen de paiement:</span>
                      <span className="info-value">{selectedOrder.paymentMethod}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Statut:</span>
                      <span className={`info-value status-badge ${getStatusClass(selectedOrder.status)}`}>
                        {selectedOrder.status}
                      </span>
                    </div>
                  </div>
                </div>
                
                <div className="order-items-section">
                  <h3>Articles commandés</h3>
                  <table className="order-items-table">
                    <thead>
                      <tr>
                        <th>Article</th>
                        <th>Quantité</th>
                        <th>Prix unitaire</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedOrder.items.map((item, index) => (
                        <tr key={index}>
                          <td>{item.name}</td>
                          <td>{item.quantity}</td>
                          <td>{item.price.toFixed(2)} €</td>
                          <td>{(item.quantity * item.price).toFixed(2)} €</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="3" className="total-label">Total</td>
                        <td className="total-value">{selectedOrder.totalAmount.toFixed(2)} €</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                
                <div className="order-actions-section">
                  <div className="status-update-section">
                    <h3>Mettre à jour le statut</h3>
                    <div className="status-buttons">
                      <button 
                        className={`status-btn ${selectedOrder.status === "Commande reçue" ? "active" : ""}`}
                        onClick={() => handleUpdateStatus(selectedOrder.id, "Commande reçue")}
                      >
                        Commande reçue
                      </button>
                      <button 
                        className={`status-btn ${selectedOrder.status === "Préparation" ? "active" : ""}`}
                        onClick={() => handleUpdateStatus(selectedOrder.id, "Préparation")}
                      >
                        Préparation
                      </button>
                      <button 
                        className={`status-btn ${selectedOrder.status === "En cours de livraison" ? "active" : ""}`}
                        onClick={() => handleUpdateStatus(selectedOrder.id, "En cours de livraison")}
                      >
                        En cours de livraison
                      </button>
                      <button 
                        className={`status-btn ${selectedOrder.status === "Livré" ? "active" : ""}`}
                        onClick={() => handleUpdateStatus(selectedOrder.id, "Livré")}
                      >
                        Livré
                      </button>
                    </div>
                  </div>
                  
                  <div className="delivery-assign-section">
                    <h3>Assigner un livreur</h3>
                    <div className="assign-form">
                      <select 
                        defaultValue={selectedOrder.deliveryPerson || ""} 
                        onChange={(e) => handleAssignDelivery(selectedOrder.id, e.target.value)}
                      >
                        <option value="">-- Sélectionner un livreur --</option>
                        {deliveryPersons.map((person, index) => (
                          <option key={index} value={person}>
                            {person}
                          </option>
                        ))}
                      </select>
                      <button 
                        className="assign-btn"
                        onClick={() => {
                          const selectElement = document.querySelector('.assign-form select');
                          if (selectElement && selectElement.value) {
                            handleAssignDelivery(selectedOrder.id, selectElement.value);
                          }
                        }}
                      >
                        Assigner
                      </button>
                    </div>
                  </div>
                  
                  <div className="contact-customer-section">
                    <h3>Contacter le client</h3>
                    <div className="contact-buttons">
                      <a href={`tel:${selectedOrder.customerPhone}`} className="contact-btn phone-btn">
                        Appeler le client
                      </a>
                      <a href={`mailto:${selectedOrder.customerEmail}`} className="contact-btn email-btn">
                        Envoyer un email
                      </a>
                    </div>
                  </div>
                </div>
                
                <div className="modal-footer">
                  <button className="cancel-btn" onClick={closeModal}>Fermer</button>
                  <button className="save-btn">Enregistrer les modifications</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrdersManagement;